import { createRoot } from 'react-dom/client';
import ErrorDisplay from '../components/ErrorDisplay';

// Create a container for the error display
const createErrorContainer = () => {
  const container = document.createElement('div');
  container.id = 'error-display-container';
  document.body.appendChild(container);
  return container;
};

// Remove the error display container
const removeErrorContainer = () => {
  const container = document.getElementById('error-display-container');
  if (container) {
    document.body.removeChild(container);
  }
};

export const showError = (error) => {
  // Check if it's a CSRF error
  const isCSRFError = error?.response?.status === 403 && 
    (error?.response?.data?.error?.includes('CSRF') || 
     error?.message?.includes('CSRF'));

  if (!isCSRFError) {
    // Let other errors propagate normally
    throw error;
  }

  return new Promise((resolve, reject) => {
    const container = createErrorContainer();
    const root = createRoot(container);

    const handleClose = () => {
      root.unmount();
      removeErrorContainer();
      reject(error); // Reject with the original error
    };

    root.render(
      <ErrorDisplay
        error={error}
        onClose={handleClose}
      />
    );
  });
};

export const handleAPIError = async (error) => {
  try {
    // Show error display for CSRF errors
    await showError(error);
  } catch (e) {
    // If showError rejects (user closed the error display) or for non-CSRF errors
    throw e;
  }
};
